import styled, { css } from 'styled-components';

import { AutoComplete } from '@xing-com/auto-complete';
import { mediaTopBarHidden } from '@xing-com/layout-tokens';
import { xdlColorSliderTickMark } from '@xing-com/tokens';

const TEXTAREA_2_LINES_HEIGHT = 78;
const TEXTAREA_5_LINES_HEIGHT = 150;
const TEXTAREA_3_LINES_HEIGHT_LG = 102;
const TEXTAREA_6_LINES_HEIGHT_LG = 174;

const CSS_HEIGHT_CONSTRAINTS = {
  TOP_BAR_VISIBLE: css`
    min-height: ${TEXTAREA_2_LINES_HEIGHT}px;
    max-height: ${TEXTAREA_2_LINES_HEIGHT}px;

    &:focus {
      max-height: ${TEXTAREA_5_LINES_HEIGHT}px;
    }
  `,
  TOP_BAR_HIDDEN: css`
    min-height: ${TEXTAREA_3_LINES_HEIGHT_LG}px;
    max-height: ${TEXTAREA_3_LINES_HEIGHT_LG}px;

    &:focus {
      max-height: ${TEXTAREA_6_LINES_HEIGHT_LG}px;
    }
  `,
};

export const Container = styled.div`
  grid-area: key;
  position: relative;
`;

export const Input = styled(AutoComplete)`
  & textarea {
    scrollbar-width: thin;
    scrollbar-color: ${xdlColorSliderTickMark} transparent;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    &:not(:focus) {
      overflow: hidden;
    }

    ${CSS_HEIGHT_CONSTRAINTS.TOP_BAR_VISIBLE}

    @media ${mediaTopBarHidden} {
      ${CSS_HEIGHT_CONSTRAINTS.TOP_BAR_HIDDEN}
    }
  }

  & ul {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`;
